module.exports = __webpack_public_path__ + "img/arrow-back-outline.c6286a8b.svg";